exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-status_save-now_2shdk {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"save-now": "save-status_save-now_2shdk",
	"saveNow": "save-status_save-now_2shdk"
};